/**
 * Public documentation site (Mintlify, built from customer-docs/ in this repo).
 *
 * Single source of truth for every docs link in the console.
 *
 * Mintlify serves this project on several hosts and they are NOT equivalent.
 * Use the one the Mintlify dashboard shows under "All changes published" —
 * that is the address the product itself hands you. Do not probe hostnames,
 * and do not switch to whatever <link rel="canonical"> says: that tag is an
 * SEO directive naming .dev, which reads as a preview environment to a human.
 *
 *   .site/docs  what the dashboard publishes to   <- use this
 *   .dev/docs   same content; what the canonical tag names
 *   .app        stale navigation, per-route edge caches that never revalidate
 *   .io         org-gated preview; sends customers to a Mintlify login wall
 *
 * The /docs base path is required: bare paths 404. It is not removable on the
 * default hosts, since the setting lives under Domain setup and cannot persist
 * without a custom domain attached — the toggle reverts on reload.
 */
export const DOCS_URL = 'https://lumoz-ai-inc.mintlify.site/docs';

/**
 * Build a v2 service-scoped path.
 *
 * @param {string|number} serviceId - The service ID (same as v1 appId)
 * @param {string} subPath - Sub-path starting with '/', e.g. '/traces'
 * @returns {string} e.g. '/v2/data/services/123/traces'
 */
export const v2ServicePath = (serviceId, subPath = '') =>
  `/v2/data/services/${serviceId}${subPath}`;
